export default __webpack_public_path__ + "static/BranchIllustration-dbe046435c57945b9b65dd068c385d46.svg";